module.exports = __webpack_public_path__ + "img/photo-0121.848de218.jpg";